import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

export const getAllPrompts = () => {
  try {
    return axios.post(
      BASE_URL + "topics/getAllPrompts",
      {},
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const deletePrompt = (prompt) => {
  try {
    return axios.post(
      BASE_URL + "topics/deletePrompt",
      { prompt },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const addNewPrompt = (prompt) => {
  try {
    return axios.post(
      BASE_URL + "topics/addNewPrompt",
      { prompt },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

// ******* CHAT *******************************************************************************************************

export const getCases = () => {
  try {
    return axios.get(BASE_URL + "cases/getCases", { headers: authHeader() });
  } catch (e) {
    console.log(e);
  }
};

export const getCaseUrl = (company_name) => {
  try {
    return axios.get(
      BASE_URL + "cases/getCaseUrl?company_name=" + company_name,
      {
        headers: authHeader(),
      },
    );
  } catch (e) {
    console.log(e);
  }
};

export const sendText = (
  question,
  chatThread,
  LLM,
  doc_ids,
  daysAgo,
  domain,
) => {
  try {
    return axios.post(
      BASE_URL + "chat/postNewChatMsg",
      { question, chatThread, LLM, doc_ids, daysAgo, domain },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const saveCase = (caseName, domain) => {
  try {
    return axios.post(
      BASE_URL + "cases/saveCase",
      { caseName, domain },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const ttsRealtime = (text) => {
  try {
    return axios.post(
      BASE_URL + "chat/ttsRealtime",
      { text },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const activateCase = (caseName, activate) => {
  try {
    return axios.post(
      BASE_URL + "cases/activateCase",
      { caseName, activate },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const deleteCase = (caseName) => {
  try {
    return axios.post(
      BASE_URL + "cases/deleteCase",
      { caseName },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getLastCaseConversations = (uuid) => {
  try {
    return axios.get(
      BASE_URL + "chat/getLastCaseConversations?currentCase=" + uuid,
      {
        headers: authHeader(),
      },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getLastCaseConversationsExplorer = (caseName) => {
  try {
    return axios.get(
      BASE_URL +
        "chat/getLastCaseConversationsExplorer?currentCase=" +
        caseName,
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const updateQaDislike = (thumb, document_id) => {
  try {
    return axios.post(
      BASE_URL + "chat/updateQaDislike",
      { thumb, document_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const updateQaLike = (thumb, document_id) => {
  try {
    return axios.post(
      BASE_URL + "chat/updateQaLike",
      { thumb, document_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const updateQaCatalog = (document_id) => {
  try {
    return axios.post(
      BASE_URL + "chat/updateQaCatalog",
      { document_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getFlatFileDocs = () => {
  try {
    return axios.get(BASE_URL + "chat/getFlatFileDocs", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getDocsbyIds = (doc_ids) => {
  try {
    return axios.get(BASE_URL + "chat/getDocsbyIds?doc_ids=" + doc_ids, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getLastExplorerGraph = (document_id) => {
  try {
    return axios.get(
      BASE_URL + "chat/getLastExplorerGraph?document_id=" + document_id,
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

//  *********************************************************************************************************************

export const getThreads = (offset, thread_type = "", search = "") => {
  try {
    let url = BASE_URL + "chat/getThreads?offset=" + offset;
    if (thread_type) url += "&thread_type=" + thread_type;
    if (search) url += "&search=" + encodeURIComponent(search);
    return axios.get(url, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const createThread = (
  thread_id,
  prompt,
  type,
  userTime,
  thread_type = "private",
  model = "",
) => {
  try {
    return axios.post(
      BASE_URL + "chat/createThread",
      { thread_id, prompt, type, userTime, thread_type, model },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const uploadFile = (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(BASE_URL + "chat/fileUpload", formData, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

// ******* PUBLIC CHAT (LiteLLM) ******************************************************************************************************

export const getEnabledPublicModels = () => {
  try {
    return axios.get(BASE_URL + "settings/getEnabledPublicModels", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const savePublicCitation = ({
  url,
  title,
  domain,
  content,
  description,
  og_image,
  direction,
}) => {
  try {
    return axios.post(
      BASE_URL + "chat/savePublicCitation",
      { url, title, domain, content, description, og_image, direction },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const scrapePublicCitation = ({ url }) => {
  try {
    return axios.post(
      BASE_URL + "chat/scrapePublicCitation",
      { url },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const renameThread = ({ thread_id, title }) => {
  try {
    return axios.post(
      BASE_URL + "chat/renameThread",
      { thread_id, title },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const deleteThread = ({ thread_id }) => {
  try {
    return axios.post(
      BASE_URL + "chat/deleteThread",
      { thread_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const batchDeleteThreads = ({ thread_ids }) => {
  try {
    return axios.post(
      BASE_URL + "chat/batchDeleteThreads",
      { thread_ids },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};
